import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { ProfileRouteGuard } from './components/auth/ProfileRouteGuard';
import * as Pages from './routes/routePages';
import { LazySpinner, ProtectedRoute, LogoutPage, RoutedErrorBoundary } from './routes/routingGuards';
import { salesRoutes } from './routes/salesRoutes';
import { financeRoutes } from './routes/financeRoutes';
import { operationsRoutes } from './routes/operationsRoutes';
import { peopleRoutes } from './routes/peopleRoutes';
import { workspaceRoutes } from './routes/workspaceRoutes';

const ConnectClaudeHelpPage = lazy(() => import('./pages/kiaan/ConnectClaudePages').then((m) => ({ default: m.ConnectClaudeHelpPage })));
const ConnectClaudeAuthorizePage = lazy(() => import('./pages/kiaan/ConnectClaudePages').then((m) => ({ default: m.ConnectClaudeAuthorizePage })));

export default function App() {
  return <Routes>
    <Route path="/login" element={<Pages.LoginPage />} />
    <Route path="/forgot-password" element={<Pages.ForgotPasswordPage />} />
    <Route path="/reset-password" element={<Pages.ResetPasswordPage />} />
    <Route path="/logout" element={<LogoutPage />} />
    <Route path="/portal/client" element={<Pages.ClientPortalPage />} />
    <Route path="/portal/vendor" element={<Pages.VendorPortalPage />} />
    <Route path="/payment-confirmation/:id" element={<Pages.PaymentConfirmationForm />} />
    <Route path="/warranty/register/:token" element={<Pages.WarrantyRegistrationPage />} />
    {/* 2026-10-08 public careers page (no login). Old /jobopenings links go to /careers. */}
    <Route path="/careers" element={<Pages.CareersListPage />} />
    <Route path="/careers/:slug" element={<Pages.CareerDetailPage />} />
    <Route path="/jobopenings" element={<Navigate to="/careers" replace />} />
    <Route path="/jobopenings/account" element={<Pages.CandidateAccountPage />} />
    <Route path="/jobopenings/:id" element={<Pages.OldJobOpeningRedirect />} />
    {/* SUN-85 Connect your Claude: help + "Allow Claude?" (handles its own sign-in, outside the shell). */}
    <Route path="/kiaan/connect-claude" element={<Suspense fallback={<LazySpinner />}><ConnectClaudeHelpPage /></Suspense>} />
    <Route path="/kiaan/connect-claude/authorize" element={<Suspense fallback={<LazySpinner />}><ConnectClaudeAuthorizePage /></Suspense>} />
    <Route path="/*" element={
      <ProtectedRoute>
        <AppShell>
          <ProfileRouteGuard>
            <RoutedErrorBoundary>
              <Suspense fallback={<LazySpinner />}>
                <Routes>
                  {salesRoutes()}
                  {financeRoutes()}
                  {operationsRoutes()}
                  {peopleRoutes()}
                  {workspaceRoutes()}
                </Routes>
              </Suspense>
            </RoutedErrorBoundary>
          </ProfileRouteGuard>
        </AppShell>
      </ProtectedRoute>
    } />
  </Routes>;
}
